import {Action} from '@ngrx/store';

import {User} from '../../model/user';
import {Lens} from '../../../lenses/shared/model/lens';
import {HttpErrorResponse} from '@angular/common/http';
import {Role} from '../../model/role';

export enum ActiveUserActionType {
  GET = '[ActiveUser] Get',
  GET_SUCCESS = '[ActiveUser] Get :: Success',

  SET_ACTIVE_USER = '[ActiveUser] Set Active User',
  SET_ACTIVE_USER_ROLE = '[ActiveUser] Set Active User Role',
  SET_ACTIVE_USER_LENS = '[ActiveUser] Set Active User Lens',

  UPLOAD_IMG = '[ActiveUser] Upload Image',
  UPLOAD_IMG_SUCCESS = '[ActiveUser] Upload Image Success',

  DELETE_IMG = '[ActiveUser] Delete Image',
  DELETE_IMG_SUCCESS = '[ActiveUser] Delete Image Success',

  CLEAR = '[ActiveUser] Clear',
}

export class GetActiveUserAction implements Action {
  public readonly type = ActiveUserActionType.GET;

  public constructor(
    public payload: {
      onSuccess?: (user: User) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetActiveUserSuccessAction implements Action {
  public readonly type = ActiveUserActionType.GET_SUCCESS;

  public constructor(public payload: {user: User}) {}
}

export class SetActiveUser implements Action {
  public readonly type = ActiveUserActionType.SET_ACTIVE_USER;

  public constructor(
    public payload: {
      user: User;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class SetActiveUserRole implements Action {
  public readonly type = ActiveUserActionType.SET_ACTIVE_USER_ROLE;

  public constructor(
    public payload: {
      role: Role;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class SetActiveUserLens implements Action {
  public readonly type = ActiveUserActionType.SET_ACTIVE_USER_LENS;

  public constructor(
    public payload: {
      lens: Lens;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class UploadImageAction implements Action {
  public readonly type = ActiveUserActionType.UPLOAD_IMG;

  public constructor(
    public payload: {
      image: Object;
      onSuccess?: (url: string) => void;
      onFailure?: (error: HttpErrorResponse) => void;
    }
  ) {}
}

export class UploadImageSuccessAction implements Action {
  public readonly type = ActiveUserActionType.UPLOAD_IMG_SUCCESS;
}

export class DeleteImageAction implements Action {
  public readonly type = ActiveUserActionType.DELETE_IMG;

  public constructor(
    public payload: {
      ids: string;
      onSuccess?: () => void;
      onFailure?: (error: HttpErrorResponse) => void;
    }
  ) {}
}

export class DeleteImageSuccessAction implements Action {
  public readonly type = ActiveUserActionType.DELETE_IMG_SUCCESS;
}

export class ClearActiveUserAction implements Action {
  public readonly type = ActiveUserActionType.CLEAR;
}

export type ActiveUserAction =
  | SetActiveUser
  | SetActiveUserRole
  | SetActiveUserLens
  | GetActiveUserAction
  | GetActiveUserSuccessAction
  | UploadImageAction
  | UploadImageSuccessAction
  | DeleteImageAction
  | DeleteImageSuccessAction
  | ClearActiveUserAction;
